import AppointmentPage from './AppointmentPage';
export default AppointmentPage;
